import { Injectable } from '@angular/core';

import { MatterHistory } from '../../models/matter-history';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class MatterHistoryService {
  /**
   * URL for matter histories controller
   * @type {String}
   */
  private matterHistoriesURL = 'matter_histories';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Edit matter history
   * @param  {number}                 matterHistoryId Id of matter history to edit
   * @return {Promise<MatterHistory>}                 Server response with matter history for editing
   */
  edit(matterHistoryId: number): Promise<MatterHistory> {
    return this.httpClient.get(`${this.matterHistoriesURL}/${matterHistoryId}/edit.json`, { get_edit: true }).then((response) => response as MatterHistory);
  }

  /**
   * Get form options for matter history form for matter
   * @param  {any       = null}        matter_id Id of matter
   * @return {Promise<any>}   Server response with form options
   */
  getFormOptions(matter_id: any = null, parent_id: any = null): Promise<any> {
    let params: any = { get_form_options: true };
    if (matter_id) params.matter_id = matter_id;
    if (parent_id) params.parent_id = parent_id;
    return this.httpClient.get(`${this.matterHistoriesURL}.json`, params);
  }

  /**
   * Get history info for expanding history
   * @param  {number}       matter_history_id Id of history
   * @return {Promise<any>}                   Server response with history info
   */
  getHistoryInfo(matter_history_id: number): Promise<any> {
    return this.httpClient.get(`${this.matterHistoriesURL}/${matter_history_id}.json`, { get_history_info: true });
  }

  /**
   * Get matter histories based on search params
   * @param  {any}          search_params Search params
   * @return {Promise<any>}               Server response with matter histories
   */
  getMatterHistories(search_params: any): Promise<any> {
    search_params.matter_history_search = true;
    return this.httpClient.get(`${this.matterHistoriesURL}.json`, search_params);
  }

  /**
   * Get search options for search filter for matter histories
   * @param  {any       = null}        matter_id Id of matter
   * @return {Promise<any>}   Server response with search options
   */
  getSearchOptions(matter_id: any = null): Promise<any> {
    let params: any = { get_search_options: true };
    if (matter_id) params.matter_id = matter_id;
    return this.httpClient.get(`${this.matterHistoriesURL}.json`, params);
  }

  /**
   * Save matter history
   * @param  {any}          params Matter history to save
   * @param  {number}       id     Id of matter history
   * @return {Promise<any>}        Server response with request result
   */
  saveMatterHistory(params: any, id: number): Promise<any> {
    if (id) {
      params.update_matter_history = true;
      return this.httpClient.put(`${this.matterHistoriesURL}/${id}.json`, params);
    } else {
      params.create_matter_history = true;
      return this.httpClient.post(`${this.matterHistoriesURL}.json`, params);
    }
  }
}
